import moment from "moment/moment";

class SubmissionReceiptController {
  constructor($scope, TimesheetService) {
    'ngInject'
    this.name = 'timesheetSubmissionReceiptController'
    this.scope = $scope

    this.timesheetsService = TimesheetService
    this.timesheet = {}

    this.data = {
      status: 'OPEN',
    }

    // Initialize signature properties
    this.signatureUrl = null;
    this.hasSignature = false;
    this.approverSignatureUrl = null;
    this.hasApproverSignature = false;

    // When current timesheet changes, sync data
    $scope.$watch(() => this.timesheetsService.currentTimesheet, (newVal, oldVal) => {
      if (!newVal && !oldVal) return

      this.setData(newVal)
    })
  }

  /**
   * Update the signature URL property
   * Called when data changes to avoid infinite digest loops
   */
  updateSignatureUrl() {
    const user = this.timesheetsService.authenticationService.user;
    if (!user || !user.signature) {
      this.signatureUrl = null;
      this.hasSignature = false;
    } else {
      this.hasSignature = true;
      this.signatureUrl = this.timesheetsService.$rootScope.apiHost + "/api/users/me/signature";
    }
    
    // Update approver signature URL
    this.updateApproverSignatureUrl();
  }

  /**
   * Update the approver signature URL property
   * Called when data changes to avoid infinite digest loops
   */
  updateApproverSignatureUrl() {
    const approver = this.timesheet.approver;
    if (!approver) {
      this.hasApproverSignature = false;
      return;
    }
    
    const approverId = approver.id || approver.userId; 
  
    this.approverSignatureUrl = this.timesheetsService.$rootScope.apiHost + "/api/timesheets/" + this.timesheet.id + "/approver-signature";
  }

  /**
   * Sync component data with given timesheet
   *
   * @param {*} timesheet
   */
  setData(timesheet) {
    this.timesheet = timesheet

    const isActionRequired = () => {
      // If its after the end date and still not approved
      return this.timesheet.status !== 'APPROVED' && moment().isAfter(moment(this.timesheet.endDate))
    }

    this.data = {
      status: this.timesheet.status,
      isApproved: this.timesheet.status === 'APPROVED',
      isActionRequired: isActionRequired(),
    }

    // Until submitDate bug is fixed assumed submitted of status is not OPEN
    if (this.timesheet.submitDate || this.timesheet.status !== 'OPEN') {
      this.data.submitted = {
        // Remove default date once submitDate bug is fixed
        date: this.timesheet.submitDate
          ? moment(this.timesheet.submitDate).format('MM/DD/YYYY')
          : '',
        name: this.timesheetsService.authenticationService.user ? this.timesheetsService.authenticationService.user.fullName : '',
      }
    }

    if (this.timesheet.approvedDate && this.timesheet.approver) {
      this.data.approved = {
        date: moment(this.timesheet.approvedDate || undefined).format('MM/DD/YYYY'),
        name: `${this.timesheet.approver.firstName} ${this.timesheet.approver.lastName}`,
      }
    }

    if (this.timesheet.status === 'REJECTED' && this.timesheet.approver) {
      this.data.rejected = {
        date: moment(this.timesheet.rejectDate || undefined).format('MM/DD/YYYY'), // Remove default date once rejectedDate is added to db
        name: `${this.timesheet.approver.firstName} ${this.timesheet.approver.lastName}`,
      }
    }

    this.data.isUnsubmitted = !this.data.submitted && moment().isAfter(moment(this.timesheet.endDate))
    
    // Update signature URL when data changes
    this.updateSignatureUrl()
  }

}

export default SubmissionReceiptController



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/submission-receipt/submission-receipt.controller.js